export const end_type = 0;
export const inactive_coils = 1;
export const End_Dia = 2;
export const HookDefAll = 3;
